import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import GlobalStyles from './styles/GlobalStyles';
import Profile from './pages/Profile';
import Blogs from './pages/Blogs';
import BlogDetailPage from './components/BlogDetailPage';
import Footer from './components/Footer';
import { StarProvider } from './context/StarContext';
import Admin from './pages/Admin';
import Login from './pages/Login';
import ErrorBoundary from './components/ErrorBoundary';
import NotFoundPage from './components/NotFoundPage';
import { AnalyticsProvider } from './context/AnalyticsContext';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [isSmallScreen, setIsSmallScreen] = useState(false);

  // const isProfilePage = location.pathname.includes('profile');
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsSmallScreen(window.innerWidth <= 768); // Adjust the width threshold as needed
  //   };
  //   handleResize(); // Check screen size initially

  //   window.addEventListener('resize', handleResize);

  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  // Function to authenticate user
  const authenticateUser = () => {
    // For simplicity, set isAuthenticated to true directly
    setIsAuthenticated(true);
  };

  return (
    <StarProvider>
      <GlobalStyles />
      <ErrorBoundary>
        <Router>
          <AnalyticsProvider>
            <Navbar />
            <Routes>
              <Route index path="/" element={<Profile />} />
              <Route path="profile/*" element={<Profile />} />
              {/* <Route path="photos" element={<Photos />} onClick={() => trackPageClick('Navigation', 'Photos')} /> */}
              <Route path="blogs" element={<Blogs />} onClick={() => trackPageClick('Navigation', 'Blogs')} />
              <Route path="/blog/:id" element={<BlogDetailPage />} />
              {/* {(isSmallScreen || isProfilePage) && (
                <>
                  <Route index path="/" element={<Profile />} />
                  <Route path="profile/*" element={<Profile />} />
                </>
              )}
              {!isSmallScreen && !isProfilePage && (
                <>
                  <Route path="blogs" element={<Blogs />} onClick={() => trackPageClick('Navigation', 'Blogs')} />
                  <Route path="/blog/:id" element={<BlogDetailPage />} />
                </>
              )} */}
              {/* Route for the login page */}
              <Route path="/login" element={<Login authenticateUser={authenticateUser} />} />

              {/* Protected route for the admin page */}
              {isAuthenticated ? (
                <Route path="/admin" element={<Admin />} />
              ) : (
                <Route path="/admin" element={<Navigate to="/login" />} />
              )}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AnalyticsProvider>
          <Footer />
        </Router>
      </ErrorBoundary>
    </StarProvider>
  );
}

export default App;
